import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let GuidedCaptureOption: LazyOption = createLazyOption(
    {
        key: 'GuidedCaptureOption',
        titleStringKey: 'optionTitle_guidedCapture',
        searchTermsStringKey: 'optionTitle_guidedCapture',
        isHidden: () => !isFeatureEnabled('cal-intelligenceOption'),
    },
    lazyFullModule,
    m => m.default
);
export default GuidedCaptureOption;
